import type {CommandSearchScope} from './types';

const GLOBAL_SEGMENT = 'global';

/** Builds a canonical scope path: `panelId/global` or `panelId/customer:10/vendor:5`. */
export const toScopePath = (scope: CommandSearchScope): string => {
    if (!scope.stack.length) {
        return `${scope.panelId}/${GLOBAL_SEGMENT}`;
    }
    const stackPath = scope.stack.map((frame) => `${frame.type}:${frame.id}`).join('/');
    return `${scope.panelId}/${stackPath}`;
};

/** Unique runtime mount key: `providerId@scopePath`. */
export const toMountKey = (providerId: string, scope: CommandSearchScope): string =>
    `${providerId}@${toScopePath(scope)}`;

/** Cache key: `scopePath::providerId::bucket` with optional query hash suffix. */
export const toCacheKey = (
    scope: CommandSearchScope,
    providerId: string,
    bucket: string,
    queryHash?: string,
): string => {
    const base = `${toScopePath(scope)}::${providerId}::${bucket}`;
    return queryHash ? `${base}::${queryHash}` : base;
};

/** Default global scope for a panel. */
export const createGlobalScope = (panelId: string): CommandSearchScope => ({
    panelId,
    stack: [],
});

/** Returns true when two scopes refer to the same canonical path. */
export const scopesEqual = (a: CommandSearchScope, b: CommandSearchScope): boolean =>
    toScopePath(a) === toScopePath(b);
